// import { api } from '@libs/api'
import { findEntityById } from '@decorators/findEntityById.ts'
import { api } from '@libs/api'
import { Button, Typography } from '@mui/material'
import { resetFilters } from '@store/campFilters/campFiltersSlice.ts'
import { getCampList } from '@store/campSearch/campSearchSlice.ts'
import { useAppDispatch, useAppSelector } from '@store/hooks.ts'
import { setSelectedMetro } from '@store/metro/metroSlice.ts'
import mixpanel from 'mixpanel-browser'
import React, { useEffect } from 'react'
import { Helmet } from 'react-helmet'
import { Link } from 'react-router-dom'
import styled from 'styled-components'

export const Terms: React.FC = () => {
  const isUserLoggedIn = api.isUserLoggedIn()
  const selectedMetro = useAppSelector((state) => state.metro.selectedMetro)
  const metros = useAppSelector((state) => state.metro.metros)
  const dispatch = useAppDispatch()

  useEffect(() => {
    if (isUserLoggedIn && !selectedMetro) {
      const metroId = api.getUserMetro()
      if (metroId && metros.length > 0) {
        dispatch(setSelectedMetro(findEntityById(metroId, metros)))
        dispatch(resetFilters())
        dispatch(getCampList())
      }
    }
    mixpanel.track_pageview({ page: 'Terms' })
    // api.setUserMetro(null)
  }, [])

  return (
    <>
      <Helmet>
        <title>Camperoni Website - Terms & Conditions</title>
        <link rel="canonical" href={`https://www.camperoni.com/terms`} />
      </Helmet>

      <Container>
        <Typography variant="h4" gutterBottom>
          Terms & Conditions
        </Typography>

        <ButtonContainer>
          <Link to="/terms/user" style={{ textDecoration: 'none' }}>
            <Button variant="contained" color="primary">
              View User Terms & Conditions
            </Button>
          </Link>
          <Link to="/terms/advertiser" style={{ textDecoration: 'none' }}>
            <Button variant="contained" color="secondary">
              View Advertiser Terms & Conditions
            </Button>
          </Link>
        </ButtonContainer>
      </Container>
    </>
  )
}

export default Terms

// Styled Components
const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem;
`

const ButtonContainer = styled.div`
  display: flex;
  gap: 1rem;
  margin-top: 2rem;
`
